import { TableProps as AntdTableProps } from 'antd';
import { StyledTable } from './TableStyles';
import { AnyObject } from 'antd/es/_util/type';
import { LoadingOutlined } from '@ant-design/icons';
import EmptyDataThumbnail from '../EmptyDataThumbnail/EmptyDataThumbnail';
import { COLORS } from '@/theme';

export type TableProps<A> = AntdTableProps<A> & {
  loading?: boolean;
};

const antIcon = <LoadingOutlined spin style={{ fontSize: 60, color: COLORS.ORANGE_PRIMARY }} />;

const Table = <A extends AnyObject>({ loading = false, pagination = false, ...props }: TableProps<A>) => {
  return (
    <StyledTable
      loading={{
        spinning: loading,
        indicator: antIcon,
      }}
      bordered
      pagination={pagination}
      rowClassName={(_, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')}
      locale={{
        emptyText: <EmptyDataThumbnail />,
      }}
      {...props}
    />
  );
};

export default Table;
